export default "__VITE_ASSET__B3KYHw11__"